import { BrandColorItem } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { BrandColorFields, brandColorsUrl } from "./cmdGetBrandColors";

export class CommandUpdateBrandColor {
    async run(organizationId: string, brandId: string, colorId: string, fields: BrandColorFields): Promise<BrandColorItem> {
        const url = `${brandColorsUrl(organizationId, brandId)}${encodeURIComponent(colorId)}/`;
        return await httpRequest<BrandColorItem>(url, { method: "PUT", body: fields });
    }
}
